import select from './HospitalMultipleSelect.vue'
const FormHospitalMultipleSelect = {
  install: function (Vue) {
    Vue.component('FormHospitalMultipleSelect', select)
  }
}
export default FormHospitalMultipleSelect
